import { z } from "zod";
import { OffsetPageQuerySchema } from "@/shared/contracts/base";

export const FormResponsesPageQuerySchema = OffsetPageQuerySchema.pick({
  limit: true,
  offset: true,
})
  .extend({
    /** JSON ຂອງ Record<fieldId, optionValue> — encode ຜ່ານ serializeFiltSearchParam */
    filt: z.string().optional(),
  })
  .transform((q) => ({
    limit: Math.min(Math.max(q.limit, 1), 200),
    offset: Math.max(q.offset, 0),
    filt: q.filt,
  }));

export type FormResponsesPageQueryDTO = z.infer<
  typeof FormResponsesPageQuerySchema
>;

export type PublicFormPublishSettingsDTO = {
  deadline?: string;
  maxResponses?: number | null;
  /** URL ชั่วคราวสำหรับแสดงแบนเนอร์ (มีเมื่อตั้งค่า poster และ object store พร้อมใช้) */
  posterUrl?: string;
};

export const PublicFormSubmitSchema = z.object({
  answers: z.array(
    z.object({
      fieldId: z.string().min(1),
      value: z.string().optional(),
      fileKey: z.string().optional(),
    }),
  ),
});

export type NormalizedAnswerInput = {
  fieldId: string;
  value: string | null;
  fileKey: string | null;
};
